module.exports = __webpack_public_path__ + "static/fontawesome-webfont.25a32416.eot";


//////////////////
// WEBPACK FOOTER
// ./src/css/assets/fonts/fontawesome-webfont.eot
// module id = ./src/css/assets/fonts/fontawesome-webfont.eot
// module chunks = 7489246917808536000